import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  fetchAnketSorulari,
  createAnketSoru,
  updateAnketSoru,
  siralaAnketSorulari,
} from '../services/anketService';
import './AnketlerPage.css';

const SETLER = [
  { id: 'musteri_kurulum', ad: 'İlk çalıştırma' },
  { id: 'musteri_ariza', ad: 'Arıza' },
  { id: 'bayi', ad: 'Bayi' },
  { id: 'teknik_servis', ad: 'Teknik servis' },
];

export default function AnketSorularPage() {
  const [set, setSet] = useState('musteri_kurulum');
  const [sorular, setSorular] = useState([]);
  const [metin, setMetin] = useState('');
  const [olumlu, setOlumlu] = useState('evet');
  const [hata, setHata] = useState('');

  const yukle = async (aktifSet) => {
    const res = await fetchAnketSorulari(aktifSet);
    setSorular(res?.veri || []);
  };

  useEffect(() => {
    yukle(set).catch((err) => setHata(err?.message || 'Sorular alınamadı'));
  }, [set]);

  const kaydet = async (soru, alan) => {
    setHata('');
    try {
      await updateAnketSoru(soru.id, alan);
      await yukle(set);
    } catch (err) {
      setHata(err?.message || 'Kaydedilemedi');
    }
  };

  const tasi = async (index, yon) => {
    const hedef = index + yon;
    if (hedef < 0 || hedef >= sorular.length) return;
    const idler = sorular.map((s) => s.id);
    const [tasinan] = idler.splice(index, 1);
    idler.splice(hedef, 0, tasinan);
    await siralaAnketSorulari(set, idler);
    await yukle(set);
  };

  const ekle = async (e) => {
    e.preventDefault();
    setHata('');
    try {
      await createAnketSoru({ set, metin, olumluCevap: olumlu });
      setMetin('');
      setOlumlu('evet');
      await yukle(set);
    } catch (err) {
      setHata(err?.message || 'Eklenemedi');
    }
  };

  return (
    <main className="main-content anketler-sayfa">
      <div className="content-header">
        <div>
          <h1>Soru setleri</h1>
        </div>
        <div className="content-header-actions">
          <Link className="secondary-btn" to="/anketler">Anketler</Link>
        </div>
      </div>
      <div className="status-tabs">
        {SETLER.map((s) => (
          <button key={s.id} type="button" className={`status-tab-btn${set === s.id ? ' active' : ''}`} onClick={() => setSet(s.id)}>
            {s.ad}
          </button>
        ))}
      </div>
      {hata ? <p>{hata}</p> : null}
      <div className="card">
        <table className="admins-table anket-tablo">
          <thead>
            <tr>
              <th>Sıra</th>
              <th>Soru</th>
              <th>Olumlu cevap</th>
              <th>Aktif</th>
            </tr>
          </thead>
          <tbody>
            {sorular.map((soru, index) => (
              <tr key={soru.id}>
                <td>
                  <div className="anket-sira">
                    <button type="button" className="secondary-btn anket-sira-btn" onClick={() => tasi(index, -1)} aria-label="Yukarı">
                      <i className="fas fa-chevron-up" />
                    </button>
                    <button type="button" className="secondary-btn anket-sira-btn" onClick={() => tasi(index, 1)} aria-label="Aşağı">
                      <i className="fas fa-chevron-down" />
                    </button>
                  </div>
                </td>
                <td>
                  <input
                    defaultValue={soru.metin}
                    key={`${soru.id}-${soru.metin}`}
                    onBlur={(e) => {
                      if (e.target.value.trim() !== soru.metin) kaydet(soru, { metin: e.target.value });
                    }}
                  />
                </td>
                <td>
                  <select
                    value={soru.olumluCevap}
                    onChange={(e) => kaydet(soru, { olumluCevap: e.target.value })}
                  >
                    <option value="evet">Evet</option>
                    <option value="hayir">Hayır</option>
                  </select>
                </td>
                <td>
                  <input
                    type="checkbox"
                    checked={soru.aktif}
                    onChange={(e) => kaydet(soru, { aktif: e.target.checked })}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <form className="anket-form" onSubmit={ekle}>
        <label>
          Yeni soru
          <textarea value={metin} onChange={(e) => setMetin(e.target.value)} rows={2} maxLength={500} required />
        </label>
        <label>
          Olumlu cevap
          <select value={olumlu} onChange={(e) => setOlumlu(e.target.value)}>
            <option value="evet">Evet</option>
            <option value="hayir">Hayır</option>
          </select>
        </label>
        <button type="submit" className="primary-btn">Ekle</button>
      </form>
    </main>
  );
}
